import {React, useState, useEffect} from "react";
import Box from "@mui/material/Box";
import {api_Routes} from "../../api_Routes";
import {Helper} from "../../tools/Helper";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import {useNavigate, useParams} from "react-router-dom";
import MainLoader from "../common/main-loader";
import GroupCard from "./group-card";
import blurGroups from "../../Assets/images/others/blurGroups.png";
import {TablePagination} from "@mui/material";
import Button from "@mui/material/Button";
import DetailsCard from "./details-card";

const SmmDomainDetails = () => {
    const {id} = useParams();
    const [Groups, setGroups] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(12);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    // useEffect(() => {
    //   get_Groups();
    // }, []);

    const get_Groups = async () => {
        const {response, message} = await Helper.Get({
            url: `${api_Routes.SmmDomain.GetOne}/${id}`,
            hasToken: true,
            data: {},
        });
        if (response) {
            setData(response.data)

        } else {
        }
        setIsLoading(false);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };

    useEffect(() => {
        get_Groups();
    }, [currentPage, rowsPerPage]);


    const goToOurServices = () => {
        window.open(`${window.location.origin}/OurServices/41/79`, '_blank', 'noopener,noreferrer');
    }


    const goToAddPanel = () => {
        window.open(`${window.location.origin}/AddGroup`, '_blank', 'noopener,noreferrer');
    }

    return (
        <>
            <Container
                sx={{
                    "@media (min-width: 1200px)": {
                        maxWidth: "1400px",
                    },
                }}
            >
                {isLoading ? (
                    <MainLoader/>
                ) : (
                    <>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "16px",
                                marginBlock: "60px",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#474747",
                                    fontSize: {xs: "20px", sm: "25px", md: "40px"},
                                    lineHeight: "40px",
                                    fontWeight: "700",
                                }}
                            >
                                That is Smm Domains
                            </Typography>
                        </Box>
                        <DetailsCard data={data} id={id}/>
                    </>
                )}
            </Container>
        </>
    );
};
export default SmmDomainDetails;
